import type { TOC } from '@ember/component/template-only';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import ToolTipComponent from 'webapp/components/tool-tip';

const TeamsViewSectionRestrictedIconComponent: TOC<Record<string, never>> = <template>
	<div class="restricted">
		<CommonUiIconComponent @name="AlertFill" @size="sm" />
		<ToolTipComponent @text="All members do not have access to the item." />
	</div>
</template>;

export default TeamsViewSectionRestrictedIconComponent;
